module.exports = function(app) {
    app.directive('wellnessTreatmentTools', function() {

        return {
            restrict: 'A',
            replace: true,
            templateUrl: 'wellness.appTemplate.html/chmhom/directives/wellnessTreatmentTools',
            controller: ['$scope','coremetrics',
                function($scope, coremetrics) {

                    $scope.cmTreatmentToolClick = function(metricsId) {
                        if (metricsId && metricsId !== '') {
                            coremetrics.elementTag(metricsId, 'MEMBER:WELLNESS');
                        }
                    };

                }
            ]
        };
    });
}